import { useTranslation } from 'react-i18next';
import { namespaces } from '~/i18n';

export const useTranslate = () => useTranslation(namespaces);
